import React from 'react';

export default function Footer() {
  return (
    <footer className="small-text mx-6 px-5 mt-3 mb-3 has-text-centered">
      <div className="session-footer">
        <span>Credit Key loans are issued by First Electronic Bank, member FDIC</span><br/>
        <a href="https://www.creditkey.com/legal/privacy-policy" target="_new">Privacy Policy</a> | <a href="https://www.creditkey.com/legal/terms-of-service-and-electronic-disclosures" target="_new">Terms of Service</a> | <a href="https://www.firstelectronic.com/privacy-policy/" target="_new">FEB Privacy Policy</a>
      </div>
    </footer>
  )
}
